import React from 'react';
import { observer } from 'mobx-react-lite';
import { OldInput } from 'src/domains/layouts/shared/formComponents/input/OldInput';
import { useAppStateContext } from 'src/AppState/AppState';
import DatePicker from 'react-datepicker';
import { InputLabel, ErrorMessageBar, InputError } from 'src/domains/layouts/shared/formComponents/FormComponents.style';
import { FormComponent, FormWrapper, DatesWrapper, DateInputWrapper } from 'src/domains/layouts/shared/cms/form/Form.style';
import { NotificationPageFormState } from './NotificationPageForm.state';
import { NotificationPageFilter } from 'src/components/NotificationPage/NotificationPageFilter';
import { FormHeader } from 'src/domains/layouts/shared/cms/form/formHeader/FormHeader';
import { FormButtons } from 'src/domains/layouts/shared/buttons/FormButtons';
import { Loader } from 'src/domains/layouts/shared/loader/Loader';

export const NotificationPageVideoForm = observer(() => {
    const { notificationPageState } = useAppStateContext();
    const [ state ] = React.useState(() => new NotificationPageFormState(notificationPageState));

    const {
        isEditMode,
        resetForm
    } = notificationPageState;

    const parsedStartDate = notificationPageState.dateFrom.value !== null ? Date.parse(notificationPageState.dateFrom.value) : null;
    const startDate = (parsedStartDate === null || isNaN(parsedStartDate)) ? null : new Date(parsedStartDate);
    const parsedEndDate = notificationPageState.dateTo.value !== null ? Date.parse(notificationPageState.dateTo.value) : null;
    const endDate = (parsedEndDate === null || isNaN(parsedEndDate)) ? null : new Date(parsedEndDate);

    return (
        <FormWrapper>
            <FormHeader isEditMode={isEditMode} defaultLabel='Create new promo page' editModeLabel='Edit promo page' resetForm={resetForm}/>
            <NotificationPageFilter />

            <FormComponent onSubmit={state.preventDefault}>
                <Loader isActive={notificationPageState.isLoading}/>

                {!!notificationPageState.errorMessage && <ErrorMessageBar>{notificationPageState.errorMessage}</ErrorMessageBar>}

                <OldInput
                    label='Title (Max 30 Characters)*'
                    status={notificationPageState.titleStatus}
                    formInputState={notificationPageState.title}
                    model={notificationPageState.titleModel}/>

                <DatesWrapper>
                    <DateInputWrapper>
                        <InputLabel>Start date *</InputLabel>
                        <DatePicker
                            selected={startDate}
                            onChange={state.onChangeStartDate}
                            onBlur={state.onBlurStartDate}
                            showTimeSelect
                            timeFormat='HH:mm'
                            timeIntervals={15}
                            timeCaption='time'
                            dateFormat='MMMM d, yyyy h:mm aa'
                        />
                        {state.startDateError ? <InputError>This field is required.</InputError> : null}
                    </DateInputWrapper>
                    <DateInputWrapper>
                        <InputLabel>End date *</InputLabel>
                        <DatePicker
                            selected={endDate}
                            onChange={state.onChangeEndDate}
                            onBlur={state.onBlurEndDate}
                            showTimeSelect
                            timeFormat='HH:mm'
                            timeIntervals={15}
                            timeCaption='time'
                            dateFormat='MMMM d, yyyy h:mm aa'
                        />
                        {state.endDateError ? <InputError>This field is required.</InputError> : null}
                    </DateInputWrapper>
                </DatesWrapper>

                <OldInput
                    label='Video URL*'
                    status={notificationPageState.videoUrlStatus}
                    formInputState={notificationPageState.videoUrl}
                    model={notificationPageState.videoUrlModel}
                />

                {notificationPageState.isFormValidVideo ? (
                    <iframe
                        title={notificationPageState.title.value}
                        src={notificationPageState.videoUrl.value}
                        frameBorder='0'
                        allow='accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture'
                        allowFullScreen
                        width='560'
                        height='315'
                    />
                ) : null}

                <FormButtons
                    onCreate={notificationPageState.handleSubmitVideo}
                    onUpdate={notificationPageState.handleSubmitVideo}
                    onCancel={notificationPageState.handleCancel}
                    isEditMode={notificationPageState.isEditMode}
                    isCreateDisabled={!notificationPageState.isFormValidVideo}
                    isUpdateDisabled={!notificationPageState.isFormValidVideo}
                />
            </FormComponent>
        </FormWrapper>
    );
});

